/**
 * Finished screen (BUILD-SPEC.md §7, hard rule §0.1): exactly one line plus
 * New standup / Resume standup. No breakdown, no copy, no share, no
 * analytics. Adding a summary/breakdown component here is a bug, not a
 * missing feature — do not "improve" this screen.
 */
import { Button, makeStyles, Text, tokens } from "@fluentui/react-components";
import { budgetSeconds, totalElapsed, type Session } from "../engine";
import { formatDuration } from "./format";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    alignItems: "flex-start",
  },
  actions: {
    display: "flex",
    gap: tokens.spacingHorizontalS,
  },
});

export interface FinishedProps {
  session: Session;
  now: number;
  onNewStandup: () => void;
  onResumeStandup: () => void;
}

export function Finished({ session, now, onNewStandup, onResumeStandup }: FinishedProps) {
  const styles = useStyles();
  const total = formatDuration(totalElapsed(session, now));
  const budget = formatDuration(budgetSeconds(session));

  return (
    <div className={styles.root}>
      <Text size={500}>
        Standup complete — {total} of a {budget} budget.
      </Text>
      <div className={styles.actions}>
        <Button appearance="primary" onClick={onNewStandup}>
          New standup
        </Button>
        <Button appearance="secondary" onClick={onResumeStandup}>
          Resume standup
        </Button>
      </div>
    </div>
  );
}
